import type { Release } from '../releases.ts';

export default {
  version: '0.14.0',
  date: '2026-10-02',
  title: 'Workspace',
  summary: [
    'Public collections that every member sees',
    'Share a personal collection with chosen people to view or edit',
    'Panes can be collapsed, closed and moved, saved for each person',
    'Fixed: browser tests follow the System status tab and the enrolment dialog',
  ],
  features: [
    'Public collections every member sees, curated by people with the new “Curate public collections” permission',
    'Share a personal collection, with its subfolders, with chosen people to view or to edit',
    'Panes in the library, on the asset page and in the editor can be collapsed, closed and moved; a Panes menu brings closed ones back and resets the layout, saved for each person',
  ],
  fixes: ['Browser tests follow the System status tab and the agent enrolment dialog'],
} satisfies Release;
